import { CheckOutlined, CloseOutlined, DeleteOutlined, Loading3QuartersOutlined } from "@ant-design/icons";
import { Tag } from "antd";

const statusConfig = {
  ACTIVATED: { color: "#c8a55a", icon: <CheckOutlined /> },
  ACTIVE: { color: "#c8a55a", icon: <CheckOutlined /> },
  APPROVE: { color: "#c8a55a", icon: <CheckOutlined /> },
  APPROVED: { color: "#c8a55a", icon: <CheckOutlined /> },
  SUCCESS: { color: "#c8a55a", icon: <CheckOutlined /> },
  YES: { color: "#c8a55a", icon: <CheckOutlined /> },
  ENABLE: { color: "#c8a55a", icon: <CheckOutlined /> },
  POSTED: { color: "#c8a55a", icon: <CheckOutlined /> },

  PENDING: { color: "#faad14", icon: <Loading3QuartersOutlined /> },
  PROCESSING: { color: "#faad14", icon: <Loading3QuartersOutlined /> },

  CANCELLED: { color: "#dc2626", icon: <CloseOutlined /> },
  REJECTED: { color: "#dc2626", icon: <CloseOutlined /> },
  FAILED: { color: "#dc2626", icon: <CloseOutlined /> },
  FALSE: { color: "#dc2626", icon: <CloseOutlined /> },
  "NOT BINDING": { color: "#dc2626", icon: <CloseOutlined /> },
  NO: { color: "#dc2626", icon: <CloseOutlined /> },
  DISABLE: { color: "#dc2626", icon: <CloseOutlined /> },
  CLOSED: { color: "#dc2626", icon: <CloseOutlined /> },
  VOID: { color: "#dc2626", icon: <CloseOutlined /> },
  DECLINED: { color: "#dc2626", icon: <CloseOutlined /> },

  DELETED: { color: "default", icon: <DeleteOutlined /> },

  HELLO: { color: "#065f46", icon: <CheckOutlined /> },
  "FOLLOW UP": { color: "#faad14" },
  ESCALATE: { color: "purple" },
  "NO REPLY": { color: "#dc2626" },
};

const Status = ({ value }) => {
  const upper = (value || "").toUpperCase();
  const config = statusConfig[upper] || {};
  return (
    <Tag color={config.color} icon={config.icon}>
      {upper}
    </Tag>
  );
};

export default Status;
